import { render, staticRenderFns } from "./RecentKills.vue?vue&type=template&id=40bff670&"
import script from "./RecentKills.vue?vue&type=script&lang=js&"
export * from "./RecentKills.vue?vue&type=script&lang=js&"
import style0 from "./RecentKills.vue?vue&type=style&index=0&id=40bff670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports